import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { ValidationFormsPage } from '@contracts';

export const Route = createFileRoute('/_app/os/validation-forms')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.ValidationForms);
  },
  component: ValidationFormsPage,
  errorComponent: ValidationFormsPage.Error,
});
